import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import {
  PlateProduct,
  WarningKey,
  Specifications,
  modificationNone,
} from '../enum'
import { Tooltip } from '@material-ui/core'
import styles from '@src/routes/Configurators/utils/styles'
import { formatOverhangSequence } from '@src/routes/Configurators/utils/formatOverhangSequence'

const useStyles = makeStyles((theme: Theme) => ({
  boxColorGreen: {
    boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.60)',
    borderRadius: '1px',
    backgroundColor: '#b7d773',
  },
  boxColorPink: {
    boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.60)',
    borderRadius: '1px',
    backgroundColor: theme.palette.sensitive.pink,
  },
  boxColorOrange: {
    boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.60)',
    borderRadius: '1px',
    backgroundColor: '#F7A703',
  },
  smallCubeColor: {
    backgroundColor: '#3f87bf',
    color: 'white',
    borderColor: theme.palette.grey[400],
  },
  boxColorGray: {
    backgroundColor: theme.palette.grey[300],
  },
  gridSide: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.grey[600],
    height: theme.spacing(10),
    width: theme.spacing(5),
    textAlign: 'center',
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(2),
  },
  gridHead: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.grey[600],
    height: theme.spacing(5),
    width: theme.spacing(10),
    textAlign: 'center',
    marginLeft: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  valid: {
    backgroundColor: '#b7d773',
    height: theme.spacing(5),
    width: theme.spacing(5),
    float: 'left',
    marginRight: theme.spacing(2),
  },
  invalid: {
    backgroundColor: theme.palette.sensitive.pink,
    height: theme.spacing(5),
    width: theme.spacing(5),
    float: 'left',
    marginRight: theme.spacing(2),
  },
  mismatch: {
    backgroundColor: '#F7A703',
    height: theme.spacing(5),
    width: theme.spacing(5),
    float: 'left',
    marginRight: theme.spacing(2),
  },
  empty: {
    backgroundColor: theme.palette.grey[300],
    height: theme.spacing(5),
    width: theme.spacing(5),
    float: 'left',
    marginRight: theme.spacing(2),
  },
  cube: {
    height: theme.spacing(7),
    width: theme.spacing(7),
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(11),
    padding: theme.spacing(1, 0, 0, 0),
    borderColor: theme.palette.grey[400],
  },
  grid: {
    cursor: 'pointer',
    height: theme.spacing(10),
    width: theme.spacing(10),
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
  },
  wellCategoryText: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
  },
  space: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    margin: theme.spacing(1),
  },
  margin: {
    padding: theme.spacing(0, 0, 9, 9),
  },
  div: {
    margin: theme.spacing(2),
  },
  leftDiv: {
    float: 'left',
    marginRight: theme.spacing(8),
  },
  head: {
    marginBottom: theme.spacing(5),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.grey[500],
  },
  w20: {
    width: '20%',
    float: 'right',
    marginTop: theme.spacing(4),
  },
  cubePadding: {
    paddingTop: theme.spacing(16),
  },
  marginSideItem: {
    marginTop: theme.spacing(58),
  },
  marginSideItem384well: {
    marginTop: theme.spacing(70),
  },
  marginSideItemDuplex: {
    marginTop: theme.spacing(51.5),
  },
  marginSideItemDuplex384well: {
    marginTop: theme.spacing(64),
  },
  link: {
    textAlign: 'center',
  },
  boxMargin: {
    margin: theme.spacing(2, 0, 0, 0),
  },
  wellShadow: {
    boxShadow: 'inset 0 2px 14px 0 rgba(0.60, 0.60, 0.60, 0.60)',
    outline: '3px solid #bdbdbd',
  },
  tab: {
    fontSize: theme.typography.pxToRem(12),
    textTransform: 'none',
    minWidth: theme.spacing(30),
  },
  sequenceInfo: {
    fontSize: theme.typography.pxToRem(14),
    paddingRight: theme.spacing(4),
  },
  InfoPopup: {
    maxWidth: 'none',
    backgroundColor: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
    color: '#1b1b25',
    boxShadow: theme.shadows[7],
  },
  arrow: {
    color: theme.palette.common.white,
  },
  wellTooltip: {
    padding: theme.spacing(2, 1, 2, 1),
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    fontWeight: theme.typography.fontWeightMedium,
    '& $activeLabel': {
      color: theme.palette.primary.main,
    },
  },
  activeLabel: {},
}))

const row1 = [
  { label: 'A' },
  { label: 'B' },
  { label: 'C' },
  { label: 'D' },
  { label: 'E' },
  { label: 'F' },
  { label: 'G' },
  { label: 'H' },
]
const row2 = [
  { label: 'I' },
  { label: 'J' },
  { label: 'K' },
  { label: 'L' },
  { label: 'M' },
  { label: 'N' },
  { label: 'O' },
  { label: 'P' },
]
const col1 = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
const col2 = [
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
]

const WellSelection = (props) => {
  const plateType = props.sessionData.plateType
  const wellType = props.sessionData.wellType
  const productDetails = props.productDetails
  let wellList
  if (productDetails.productType === PlateProduct.DuplexPlate) {
    wellList = props.sessionData.biTubeWellList
  } else {
    wellList = props.sessionData.wellList
  }
  const onWellclick = props.onWellclick
  const [tabValue, setTabValue] = React.useState(0)
  const classes = useStyles()
  const GlobalCSS = styles()
  const [click, setClick] = React.useState(0)
  const renderData = (props, wellList, rows, cols, tabValue) => {
    const wellSelected = (id, well, row, col) => {
      setClick(id)
      props.populateData(well, row, col)
    }
    if (tabValue === 0) {
      rows = row1
      cols = col1
    }
    if (tabValue === 1) {
      rows = row1
      cols = col2
    }
    if (tabValue === 2) {
      rows = row2
      cols = col1
    }
    if (tabValue === 3) {
      rows = row2
      cols = col2
    }
    return (
      <div>
        <Grid container spacing={0}>
          <Grid item>
            <Grid className={classes.space}></Grid>
          </Grid>
          {cols.map((count, index) => (
            <Grid item key={index}>
              <Grid className={classes.gridHead}>{count}</Grid>
            </Grid>
          ))}
        </Grid>
        {rows.map((row, indexrow) => (
          <Grid container spacing={0} key={indexrow}>
            <Grid item>
              <Grid className={classes.gridSide}>{row.label}</Grid>
            </Grid>
            {cols.map((count, index) => {
              let well: any = []
              let plate
              if (productDetails.productType === PlateProduct.DuplexPlate) {
                plate = {
                  name: '',
                  sequence: '',
                  customerOverhang: '',
                  threeMod: '',
                  fiveMod: '',
                  listError: [],
                  listWarning: [],
                  row: '',
                  column: '',
                  id: 0,
                  baseCount: 0,
                  antisenceBaseCount: 0,
                  antisenceName: '',
                  antisenceFiveMod: '',
                  antisenceSequence: '',
                  customerAntisenseOverHang: '',
                  antisenceThreeMod: '',
                  senseNameCheck: false,
                  autoGenerateOligo: false,
                  isOverridden: props.sessionData.isOverridden,
                }
              } else {
                plate = {
                  name: '',
                  sequence: '',
                  threeMod: '',
                  fiveMod: '',
                  listError: [],
                  row: '',
                  column: '',
                  id: 0,
                  baseCount: 0,
                  isOverridden: props.sessionData.isOverridden,
                  wellType: wellType,
                  mixed: plateType === Specifications.MIXED ? 1 : null,
                }
              }

              let wellEmpty = [plate]
              wellList.forEach((plates) => {
                if (plates.row === row.label && plates.column === count) {
                  plate = plates
                  well = well.concat(plate)
                }
              })
              if (plate.row === '' && plate.column === '') {
                if (plateType !== 'STANDARD') {
                  wellEmpty = wellEmpty.concat(plate)
                }
                return (
                  <Grid item key={index}>
                    <Grid
                      className={clsx(classes.grid, classes.boxColorGray)}
                      onClick={() =>
                        wellSelected(plate.id, wellEmpty, row.label, count)
                      }
                    ></Grid>
                  </Grid>
                )
              }
              if (plateType === 'STANDARD') {
                if (plate.listError.length === 0) {
                  if (productDetails.productType === PlateProduct.DuplexPlate) {
                    let warningCount = 0
                    plate.listWarning.forEach((warning) => {
                      if (
                        warning.key === WarningKey.antisencesequence_mismatch
                      ) {
                        warningCount = warningCount + 1
                      }
                    })
                    if (warningCount === 0) {
                      return (
                        <Grid item key={index}>
                          <Tooltip
                            title={
                              <Grid className={classes.wellTooltip}>
                                <div>
                                  <span className={classes.sequenceInfo}>
                                    <strong> {well[0].name}: </strong>
                                  </span>
                                  <span>
                                    {well[0].fiveMod !== modificationNone.none
                                      ? well[0].fiveMod
                                      : ''}
                                    {well[0].sequence}
                                    {well[0].customerOverhang &&
                                      formatOverhangSequence(
                                        well[0].customerOverhang
                                      )}
                                    {well[0].threeMod !== modificationNone.none
                                      ? well[0].threeMod
                                      : ''}
                                  </span>
                                </div>
                                <div>
                                  <span className={classes.sequenceInfo}>
                                    <strong> {well[0].antisenceName}: </strong>
                                  </span>
                                  {well[0].antisenceFiveMod !==
                                  modificationNone.none
                                    ? well[0].antisenceFiveMod
                                    : ''}
                                  {well[0].antisenceSequence}
                                  {well[0].customerAntisenseOverHang &&
                                    formatOverhangSequence(
                                      well[0].customerAntisenseOverHang
                                    )}
                                  {well[0].antisenceThreeMod !==
                                  modificationNone.none
                                    ? well[0].antisenceThreeMod
                                    : ''}
                                </div>
                              </Grid>
                            }
                            classes={{
                              tooltip: classes.InfoPopup,
                              arrow: classes.arrow,
                            }}
                            arrow
                            placement="bottom-start"
                          >
                            <Grid
                              onClick={() =>
                                wellSelected(plate.id, well, row.label, count)
                              }
                              className={clsx(
                                classes.boxColorGreen,
                                classes.grid,
                                click === plate.id && onWellclick
                                  ? classes.wellShadow
                                  : ''
                              )}
                              id={`plate-well-${plate.id}`}
                              data-testid={`plate-well-${plate.id}`}
                            ></Grid>
                          </Tooltip>
                        </Grid>
                      )
                    } else {
                      return (
                        <Grid item key={index}>
                          <Tooltip
                            title={
                              <Grid className={classes.wellTooltip}>
                                <div>
                                  <span className={classes.sequenceInfo}>
                                    <strong> {well[0].name}: </strong>
                                  </span>
                                  <span>{well[0].sequence}</span>
                                </div>
                                <div>
                                  <span className={classes.sequenceInfo}>
                                    <strong> {well[0].antisenceName}: </strong>
                                  </span>
                                  <span>{well[0].antisenceSequence}</span>
                                </div>
                              </Grid>
                            }
                            classes={{
                              tooltip: classes.InfoPopup,
                              arrow: classes.arrow,
                            }}
                            arrow
                            placement="bottom-start"
                          >
                            <Grid
                              onClick={() =>
                                wellSelected(plate.id, well, row.label, count)
                              }
                              className={clsx(
                                classes.boxColorOrange,
                                classes.grid,
                                click === plate.id && onWellclick
                                  ? classes.wellShadow
                                  : ''
                              )}
                            ></Grid>
                          </Tooltip>
                        </Grid>
                      )
                    }
                  } else {
                    return (
                      <Grid item key={index}>
                        <Tooltip
                          title={
                            <Grid className={classes.wellTooltip}>
                              <span className={classes.sequenceInfo}>
                                <strong> {well[0].name}: </strong>
                              </span>
                              <span>
                                {well[0].fiveMod !== modificationNone.none
                                  ? well[0].fiveMod
                                  : ''}
                                {well[0].sequence}
                                {well[0].customerOverhang &&
                                  formatOverhangSequence(
                                    well[0].customerOverhang
                                  )}
                                {well[0].threeMod !== modificationNone.none
                                  ? well[0].threeMod
                                  : ''}
                              </span>
                            </Grid>
                          }
                          classes={{
                            tooltip: classes.InfoPopup,
                            arrow: classes.arrow,
                          }}
                          arrow
                          placement="bottom-start"
                        >
                          <Grid
                            onClick={() =>
                              wellSelected(plate.id, well, row.label, count)
                            }
                            className={clsx(
                              classes.boxColorGreen,
                              classes.grid,
                              click === plate.id && onWellclick
                                ? classes.wellShadow
                                : ''
                            )}
                            id={`plate-well-${plate.id}`}
                            data-testid={`plate-well-${plate.id}`}
                          ></Grid>
                        </Tooltip>
                      </Grid>
                    )
                  }
                } else if (plate.listError.length !== 0) {
                  return (
                    <Grid item key={index}>
                      <Grid
                        className={clsx(
                          classes.boxColorPink,
                          classes.grid,
                          click === plate.id && onWellclick
                            ? classes.wellShadow
                            : ''
                        )}
                        onClick={() =>
                          wellSelected(plate.id, well, row.label, count)
                        }
                      ></Grid>
                    </Grid>
                  )
                }
              } else {
                if (
                  well[0]?.listError.length === 0 &&
                  well[1]?.listError.length === 0
                ) {
                  return (
                    <Grid item key={index}>
                      <Tooltip
                        title={
                          <Grid className={classes.wellTooltip}>
                            <div>
                              <span className={classes.sequenceInfo}>
                                <strong> {well[0].name}: </strong>
                              </span>
                              <span>
                                {well[0].fiveMod !== modificationNone.none
                                  ? well[0].fiveMod
                                  : ''}
                                {well[0].sequence}
                                {well[0].customerOverhang &&
                                  formatOverhangSequence(
                                    well[0].customerOverhang
                                  )}
                                {well[0].threeMod !== modificationNone.none
                                  ? well[0].threeMod
                                  : ''}
                              </span>
                            </div>
                            <div>
                              <span className={classes.sequenceInfo}>
                                <strong> {well[1].name}: </strong>
                              </span>
                              <span>
                                {well[1].fiveMod !== modificationNone.none
                                  ? well[1].fiveMod
                                  : ''}
                                {well[1].sequence}
                                {well[1].customerOverhang &&
                                  formatOverhangSequence(
                                    well[1].customerOverhang
                                  )}
                                {well[1].threeMod !== modificationNone.none
                                  ? well[1].threeMod
                                  : ''}
                              </span>
                            </div>
                          </Grid>
                        }
                        classes={{
                          tooltip: classes.InfoPopup,
                          arrow: classes.arrow,
                        }}
                        arrow
                        placement="bottom-start"
                      >
                        <Grid
                          onClick={() =>
                            wellSelected(plate.id, well, row.label, count)
                          }
                          className={clsx(
                            classes.boxColorGreen,
                            classes.grid,
                            click === plate.id && onWellclick
                              ? classes.wellShadow
                              : ''
                          )}
                          id={`plate-well-${plate.id}`}
                          data-testid={`plate-well-${plate.id}`}
                        ></Grid>
                      </Tooltip>
                    </Grid>
                  )
                } else if (
                  well[0]?.listError.length !== 0 ||
                  well[1]?.listError.length !== 0
                ) {
                  return (
                    <Grid item key={index}>
                      <Grid
                        className={clsx(
                          classes.boxColorPink,
                          classes.grid,
                          click === plate.id && onWellclick
                            ? classes.wellShadow
                            : ''
                        )}
                        onClick={() =>
                          wellSelected(plate.id, well, row.label, count)
                        }
                      ></Grid>
                    </Grid>
                  )
                }
              }
              return false
            })}
          </Grid>
        ))}
      </div>
    )
  }
  return (
    <div>
      <Paper elevation={0}>
        <div className={classes.margin}>
          <div className={classes.leftDiv}>
            <div className={classes.head}>
              {wellType === PlateProduct.wellType ? (
                <Tabs
                  value={tabValue}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={(e, value) => setTabValue(value)}
                >
                  <Tab label="Quadrant 1" className={classes.tab} />
                  <Tab label="Quadrant 2" className={classes.tab} />
                  <Tab label="Quadrant 3" className={classes.tab} />
                  <Tab label="Quadrant 4" className={classes.tab} />
                </Tabs>
              ) : (
                ''
              )}
            </div>
            {renderData(props, wellList, row1, col1, tabValue)}
          </div>
          <div>
            <div className={classes.cubePadding}>
              {wellType === PlateProduct.wellType ? (
                <>
                  <p
                    className={clsx(
                      classes.wellCategoryText,
                      GlobalCSS.globalBlackFontColor
                    )}
                  >
                    <FormattedMessage {...messages.CONF_DNAPLATES_PLATE} />
                  </p>
                  <p
                    className={clsx(
                      classes.wellCategoryText,
                      GlobalCSS.globalBlackFontColor
                    )}
                  >
                    <FormattedMessage {...messages.CONF_DNAPLATES_QUADRANT} />
                  </p>
                  <Box className={classes.boxMargin}>
                    <Box display="flex">
                      <Box
                        border={1}
                        className={clsx(
                          classes.cube,
                          tabValue === 0 ? classes.smallCubeColor : ''
                        )}
                      >
                        <FormattedMessage {...messages.CONF_DNAPLATES_1} />
                      </Box>
                      <Box
                        border={1}
                        className={clsx(
                          classes.cube,
                          tabValue === 2 ? classes.smallCubeColor : ''
                        )}
                      >
                        <FormattedMessage {...messages.CONF_DNAPLATES_3} />
                      </Box>
                    </Box>
                    <Box display="flex">
                      <Box
                        border={1}
                        className={clsx(
                          classes.cube,
                          tabValue === 1 ? classes.smallCubeColor : ''
                        )}
                      >
                        <FormattedMessage {...messages.CONF_DNAPLATES_2} />
                      </Box>
                      <Box
                        border={1}
                        className={clsx(
                          classes.cube,
                          tabValue === 3 ? classes.smallCubeColor : ''
                        )}
                      >
                        <FormattedMessage {...messages.CONF_DNAPLATES_4} />
                      </Box>
                    </Box>
                  </Box>
                </>
              ) : (
                ''
              )}
            </div>
            <div
              className={
                productDetails.productType === PlateProduct.DuplexPlate
                  ? wellType === PlateProduct.wellType
                    ? classes.marginSideItemDuplex
                    : classes.marginSideItemDuplex384well
                  : wellType === PlateProduct.wellType
                    ? classes.marginSideItem
                    : classes.marginSideItem384well
              }
            >
              <div className={classes.div}>
                <Grid className={classes.empty}></Grid>{' '}
                <p
                  className={clsx(
                    classes.wellCategoryText,
                    GlobalCSS.globalBlackFontColor
                  )}
                >
                  <FormattedMessage {...messages.CONF_DNAPLATES_EMPTY_WELLS} />
                </p>
              </div>
              <div className={classes.div}>
                {' '}
                <Grid className={classes.valid}></Grid>{' '}
                <p
                  className={clsx(
                    classes.wellCategoryText,
                    GlobalCSS.globalBlackFontColor
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_VALID_SEQUENCE}
                  />
                </p>
              </div>
              <div className={classes.div}>
                <Grid className={classes.invalid}></Grid>{' '}
                <p
                  className={clsx(
                    classes.wellCategoryText,
                    GlobalCSS.globalBlackFontColor
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_INVALID_SEQUENCE}
                  />
                </p>
              </div>
              {productDetails.productType === PlateProduct.DuplexPlate ? (
                <div className={classes.div}>
                  <Grid className={classes.mismatch}></Grid>{' '}
                  <p
                    className={clsx(
                      classes.wellCategoryText,
                      GlobalCSS.globalBlackFontColor
                    )}
                  >
                    <FormattedMessage
                      {...messages.CONF_DNAPLATES_MISMATCH_SEQUENCE}
                    />
                  </p>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default WellSelection
